import { initialState } from "@/store/modules/attributes/state";

export default {
  RESET_STORE(state) {
    Object.keys(initialState).forEach(key => {
      Object.assign(state[key], initialState[key]);
    });
  },

  SET_AVAILABLE_ATTRIBUTES: (state, payload) => {
    state.availableAttributes = payload;
  },

  SET_ATTRIBUTES: (state, payload) => {
    state.attributes = [...payload];
  }
};
